window.addEventListener('DOMContentLoaded', () => {
  // ================================================================================
  // ヘッダー　カートアイコン
  // ================================================================================
   const cartIcon = document.getElementById('cart-icon-bubble');
    const cartContainer = document.querySelector('.cart__container');

    // カートアイコンをクリックしたときの処理
    cartIcon.addEventListener('click', function(event) {
        event.stopPropagation(); // イベントの伝播を停止
        cartContainer.classList.toggle('is-active');
    });

    // ドキュメント全体をクリックしたときの処理
    document.addEventListener('click', function(event) {
        // クリックされた要素がcart__container内にない場合、is-activeクラスを削除
        if (!cartContainer.contains(event.target) && !cartIcon.contains(event.target)) {
            cartContainer.classList.remove('is-active');
        }
    });
  
  // ================================================================================
  // ヘッダー　検索窓サジェスト機能
  // ================================================================================
  // const searchContainers = document.querySelectorAll('.search-modal__form');
  // const suggests = document.querySelectorAll('.suggest');
  // let isSearchActive = false;

  // // ドキュメント全体のクリックイベント
  // document.addEventListener('click', (event) => {
  //   const isClickInsideSearch = Array.from(searchContainers).some(container => 
  //     container.contains(event.target) || container.nextElementSibling.contains(event.target)
  //   );
  //   if (isSearchActive && !isClickInsideSearch) {
  //     suggests.forEach(suggest => suggest.classList.remove('is-show'));
  //     isSearchActive = false;
  //   }
  // });

  // // 検索入力欄のクリックイベント
  // const searchInputs = document.querySelectorAll('.search__input');
  // searchInputs.forEach(input => {
  //    input.addEventListener('input', () => {
  //     // event.stopPropagation(); 
  //     const suggest = input.closest('.header__search-container').querySelector('.suggest');
  //     if (input.value.trim() !== '') { // 入力がある場合
  //     suggest.classList.add('is-show');
  //     isSearchActive = true;
  //   } else {
  //     suggest.classList.remove('is-show');
  //     isSearchActive = false;
  //   }
  //   });
  // });

  // // キーワードのクリックイベント
  // const keywordItems = document.querySelectorAll('.suggest__keyword');
  // keywordItems.forEach(item => {
  //   item.addEventListener('click', (event) => {
  //     event.stopPropagation(); // イベントの伝播を停止
  //     const keyword = event.target.textContent.trim();
  //     const searchInput = item.closest('.suggest').previousElementSibling.querySelector('.search__input');
  //     searchInput.value = keyword;
  //     searchInput.focus(); // 入力欄にフォーカスを移動
      
  //     // サジェストを非表示にする
  //     suggests.forEach(suggest => suggest.classList.remove('is-show'));
  //     isSearchActive = false;
  //   });
  // });


  // ================================================================================
  // ヘッダー　メガメニュー
  // ================================================================================
  const menuItems = document.querySelectorAll('.header__menu-item');
  let isInitialized = false;
  let currentOpenMenu = null;
  const HOVER_DELAY = 250; // ホバー時の遅延（ミリ秒）
  
  setTimeout(() => {
    isInitialized = true;
    menuItems.forEach(item => {
      const parentLi = item.closest('li');
      const megaMenu = parentLi.querySelector('.mega-menu__content');
      if (megaMenu) {
        let timeoutId;
  
        const showMegaMenu = () => {
          if (!isInitialized) return;
          clearTimeout(timeoutId);
          if (currentOpenMenu && currentOpenMenu !== megaMenu) {
            hideMegaMenu(currentOpenMenu);
          }
          timeoutId = setTimeout(() => {
            megaMenu.classList.add('is-show');
            currentOpenMenu = megaMenu;
          }, HOVER_DELAY);
        };
  
        const hideMegaMenu = (menu) => {
          if (!isInitialized) return;
          clearTimeout(timeoutId);
          timeoutId = setTimeout(() => {
            menu.classList.remove('is-show');
            if (currentOpenMenu === menu) {
              currentOpenMenu = null;
            }
          }, HOVER_DELAY);
        };
  
        const handleMouseEnter = () => {
          clearTimeout(timeoutId);
          showMegaMenu();
        };
  
        const handleMouseLeave = () => {
          hideMegaMenu(megaMenu);
        };
  
        item.addEventListener('mouseenter', handleMouseEnter);
        megaMenu.addEventListener('mouseenter', handleMouseEnter);
        item.addEventListener('mouseleave', handleMouseLeave);
        megaMenu.addEventListener('mouseleave', handleMouseLeave);
  
        // キーボードナビゲーション対応
        item.addEventListener('focus', showMegaMenu);
        parentLi.addEventListener('focusout', (event) => {
          if (!parentLi.contains(event.relatedTarget)) {
            hideMegaMenu(megaMenu);
          }
        });
      }
    });
  }, 1000); // 1秒の遅延を設定
  
  // ================================================================================
  // ヘッダー　アコーディオン  
  // ================================================================================
  const initializeDetailsAccordion = (details) => {
    const summary = details.querySelector('summary');
    const panel = details.querySelector('summary + *');
  
    if (!(details && summary && panel)) return; // 必要要素が揃ってない場合は処理をやめる
  
    let isTransitioning = false; // 連打防止フラグ
  
    const onOpen = () => {
      if (details.open || isTransitioning) {
        return;
      }
      isTransitioning = true;
      details.setAttribute('open', '');
      panel.style.blockSize = '0px';
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          panel.style.blockSize = `${panel.scrollHeight}px`;
        });
      });
      panel.addEventListener(
        'transitionend',
        () => {
          panel.style.blockSize = '';
          isTransitioning = false;
        },
        { once: true },
      );
    };
  
    const onClose = () => {
      if (!details.open || isTransitioning) {
        return;
      }
      isTransitioning = true;
      panel.style.blockSize = `${panel.scrollHeight}px`;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          panel.style.blockSize = '0';
        });
      });
      panel.addEventListener(
        'transitionend',
        () => {
          details.removeAttribute('open');
          panel.style.blockSize = '';
          isTransitioning = false;
        },
        { once: true },
      );
    };
  
    summary.addEventListener('click', (event) => {
      event.preventDefault();
  
      if (details.open) {
        onClose();
      } else {
        onOpen();
      }
    });
  };
  
  document.querySelectorAll('.menu-drawer__details').forEach((accordion) => {
    initializeDetailsAccordion(accordion);
  });
  
  // ================================================================================
  // ヘッダー子メニュー　アコーディオン  
  // ================================================================================
  const initializeDetailsAccordion_child = (details) => {
    const summary = details.querySelector('summary');
    const panel = details.querySelector('summary + *');
  
    if (!(details && summary && panel)) return; // 必要要素が揃ってない場合は処理をやめる
  
    let isTransitioning = false; // 連打防止フラグ
  
    const onOpen = () => {
      if (details.open || isTransitioning) {
        return;
      }
      isTransitioning = true;
      details.setAttribute('open', '');
      panel.style.blockSize = '0px';
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          panel.style.blockSize = `${panel.scrollHeight}px`;
        });
      });
      panel.addEventListener(
        'transitionend',
        () => {
          panel.style.blockSize = '';
          isTransitioning = false;
        },
        { once: true },
      );
    };
  
    const onClose = () => {
      if (!details.open || isTransitioning) {
        return;
      }
      isTransitioning = true;
      panel.style.blockSize = `${panel.scrollHeight}px`;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          panel.style.blockSize = '0';
        });
      });
      panel.addEventListener(
        'transitionend',
        () => {
          details.removeAttribute('open');
          panel.style.blockSize = '';
          isTransitioning = false;
        },
        { once: true },
      );
    };
  
    summary.addEventListener('click', (event) => {
      event.preventDefault();
  
      if (details.open) {
        onClose();
      } else {
        onOpen();
      }
    });
  };
  
  document.querySelectorAll('.menu-drawer__child-details').forEach((accordion) => {
    initializeDetailsAccordion_child(accordion);
  });

  // ================================================================================
  // フッターメニュー　アコーディオン  
  // ================================================================================
  const rootStyles = getComputedStyle(document.documentElement);
  const breackpointMd = rootStyles.getPropertyValue('--breackpoint-md').trim();
  const mediaQueryList = window.matchMedia(`(max-width: ${breackpointMd})`);
  
  const initializeDetailsAccordion_footer = (details) => {
    const summary = details.querySelector('summary');
    const panel = details.querySelector('summary + *');
  
    if (!(details && summary && panel)) return; // 必要要素が揃ってない場合は処理をやめる
  
    let isTransitioning = false; // 連打防止フラグ
  
    const onOpen = () => {
      if (details.open || isTransitioning) {
        return;
      }
      isTransitioning = true;
      details.setAttribute('open', '');
      panel.style.blockSize = '0px';
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          panel.style.blockSize = `${panel.scrollHeight}px`;
        });
      });
      panel.addEventListener(
        'transitionend',
        () => {
          panel.style.blockSize = '';
          isTransitioning = false;
        },
        { once: true },
      );
    };
  
    const onClose = () => {
      if (!details.open || isTransitioning) {
        return;
      }
      isTransitioning = true;
      panel.style.blockSize = `${panel.scrollHeight}px`;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          panel.style.blockSize = '0';
        });
      });
      panel.addEventListener(
        'transitionend',
        () => {
          details.removeAttribute('open');
          panel.style.blockSize = '';
          isTransitioning = false;
        },
        { once: true },
      );
    };
  
    summary.addEventListener('click', (event) => {
      event.preventDefault();
  
      if (details.open) {
        onClose();
      } else {
        onOpen();
      }
    });
  };

  // ブレイクポイントでopen属性の付け外し
  const mediaQueryFunction = (event) => {
    document.querySelectorAll('.footer-nav__details').forEach((details) => {
      if (event.matches) {
        details.removeAttribute('open');
      } else {
        details.setAttribute('open', '');
      }
    });
  };

  // ブレイクポイントが変わった時のイベントを登録
  mediaQueryList.addEventListener('change', mediaQueryFunction);
  
  // ページ読み込み時のイベントを登録
  mediaQueryFunction(mediaQueryList);
  document.querySelectorAll('.footer-nav__details').forEach((accordion) => {
    initializeDetailsAccordion_footer(accordion);
  });


  // ================================================================================
  // フッター バナースライダー
  // ================================================================================
  const footerSliderElement = document.querySelector(".footer-slider");    
  if (footerSliderElement) {
    const footerSlider = new Splide(footerSliderElement, {
      autoplay     : true, // 自動再生
      type         : "loop", // ループ
      pauseOnHover : false, // カーソルが乗ってもスクロールを停止させない
      pauseOnFocus : false, // 矢印をクリックしてもスクロールを停止させない
      interval     : 2000, // 自動再生の間隔
      speed        : 1000, // スライダーの移動時間
      gap          : 12, // スライド間の余白
      padding      : {
        left: 'calc(40 / 390 * 100%)', // 左側のパディング
        right: 'calc(40 / 390 * 100%)', // 左側のパディング
      },
      pagination: false, // ページネーションオフ
    }).mount();
  }


  // ================================================================================
  // SP用フロートメニュー
  // ================================================================================
const floatMenu = document.querySelector(".float");
  const header = document.querySelector(".header-wrapper");
  const footer = document.querySelector(".footer");

  window.addEventListener("scroll", function () {
    if (window.innerWidth <= 768) {
      const offsetTop = window.pageYOffset;
      const windowHeight = window.innerHeight;

      const headerBottom = header.getBoundingClientRect().bottom + offsetTop - 1;
      const footerTop = footer.getBoundingClientRect().top + offsetTop;

      if ((headerBottom <= offsetTop) && (footerTop >= offsetTop + windowHeight)) {
      floatMenu.style.transform = "translate(0, 0%)";
      } else {
      floatMenu.style.transform = "translate(0, 100%)";
      }
    }
  });
  
  // ================================================================================
  // トップページ　メインスライダー
  // ================================================================================

  const MainSliderElement = document.querySelector(".main-slider");
  let MainSlider;

  if (MainSliderElement) {
    MainSlider = new Splide(MainSliderElement, {
      autoplay     : true, // 自動再生
      type         : "loop", // ループ
      pauseOnHover : false, // カーソルが乗ってもスクロールを停止させない
      pauseOnFocus : false, // 矢印をクリックしてもスクロールを停止させない
      // rewind    : true,
      pagination   : false,
      gap          : 8,
      padding      : {
        left: 'calc(354 / 1728 * 100%)', // 左側のパディング
        right: 'calc(354 / 1728 * 100%)', // 右側のパディング
      },
      breakpoints: {
        768: {
          pagination : true,
          gap        : 0,
          padding    : 0,
        }
      }
    });
  }
  
  const ThumbnailElement = document.querySelector(".thumbnail-slider");
  let ThumbnailSlider;

  if (ThumbnailElement) {
    ThumbnailSlider = new Splide(ThumbnailElement, {
      fixedWidth   : 242,
      gap          : 8,
      rewind       : true,
      pagination   : false,
      arrows       : false,
      isNavigation : true,
      breakpoints  : {
        1200: {
          fixedWidth : 200,
        },
        992: {
          fixedWidth : 150,
        },
        768: {
          fixedWidth : 100,
        }
      }
    });
  }
  
  if(MainSliderElement && ThumbnailElement) {
    MainSlider.sync( ThumbnailSlider );
    MainSlider.mount();
    ThumbnailSlider.mount();
  }

    
  // ================================================================================
  // コレクションページ　サブカテゴリ　アコーディオン  
  // ================================================================================
  const initializeDetailsAccordion_category = (details) => {
    const summary = details.querySelector('summary');
    const panel = details.querySelector('summary + *');
  
    if (!(details && summary && panel)) return; // 必要要素が揃ってない場合は処理をやめる

    let isTransitioning = false; // 連打防止フラグ
  
    const onOpen = () => {
      if (details.open || isTransitioning) {
        return;
      }
      isTransitioning = true;
      details.setAttribute('open', '');
      panel.style.blockSize = '0px';
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          panel.style.blockSize = `${panel.scrollHeight}px`;
        });
      });
      panel.addEventListener(
        'transitionend',
        () => {
          panel.style.blockSize = '';
          isTransitioning = false;
        },
        { once: true },
      );
    };
  
    const onClose = () => {
      if (!details.open || isTransitioning) {
        return;
      }
      isTransitioning = true;
      panel.style.blockSize = `${panel.scrollHeight}px`;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          panel.style.blockSize = '0';
        });
      });
      panel.addEventListener(
        'transitionend',
        () => {
          details.removeAttribute('open');
          panel.style.blockSize = '';
          isTransitioning = false;
        },
        { once: true },
      );
    };
  
    summary.addEventListener('click', (event) => {
      event.preventDefault();
  
      if (details.open) {
        onClose();
      } else {
        onOpen();
      }
    });
  };
  
  document.querySelectorAll('.collection-category__accordion').forEach((accordion) => {
    initializeDetailsAccordion_category(accordion);
  });
});

// ================================================================================
  // 商品詳細ページ　タブ切替  
  // ================================================================================

$(function() {
  $('.tab').on('click', function() {
    $('.tab, .panel').removeClass('active');
  
    $(this).addClass('active');
     
    var index = $('.tab').index(this);
    $('.panel').eq(index).addClass('active');
  });
});

// ================================================================================
// Smart Product Filter & Search 閲覧履歴デザイン調整
// ================================================================================
function prefillGfSearchInputFromUrl() {
  const params = new URLSearchParams(window.location.search);
  const q = params.get('q');
  if (!q) return;
  const inputs = document.querySelectorAll('.gf-controls-search-input');
  inputs.forEach(input => {
    if (input.dataset.qPrefilled === 'true') return;
    input.value = q;
    input.setAttribute('value', q);
    input.dataset.qPrefilled = 'true';
  });
}

prefillGfSearchInputFromUrl();
document.addEventListener('DOMContentLoaded', prefillGfSearchInputFromUrl);

const spfobserver = new MutationObserver(() => {
  // SALE ラベルの書き換え
  const saleLabels = document.querySelectorAll('.spf-product__label-sale');
  saleLabels.forEach(label => {
    if (!label.classList.contains('sale-updated')) {
      label.textContent = 'SALE';
      label.classList.add('sale-updated');
    }
  });

  // 売り切れラベルの書き換え
  const soldoutLabels = document.querySelectorAll('.spf-product__label-soldout');
  soldoutLabels.forEach(label => {
    if (!label.classList.contains('soldout-updated')) {
      label.textContent = '売り切れ';
      label.classList.add('soldout-updated');
    }
  });

  // Globo Filter の検索input にURLの q を入れる（アプリがJSで動的生成するため）
  prefillGfSearchInputFromUrl();
});

spfobserver.observe(document.body, {
  childList: true,
  subtree: true
});